var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitchen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 113,
    viewBox: "0 0 141 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141 42.375H112.8V21.1875C112.8 9.46375 103.353 0 91.65 0C79.947 0 70.5 9.46375 70.5 21.1875H84.6C84.6 17.3031 87.7725 14.125 91.65 14.125C95.5275 14.125 98.7 17.3031 98.7 21.1875V42.375H42.3C50.055 42.375 56.4 36.0188 56.4 28.25V0H14.1V28.25C14.1 36.0188 20.445 42.375 28.2 42.375H0V56.5H14.1V113H126.9V56.5H141V42.375ZM28.2 14.125H42.3V28.25H28.2V14.125ZM28.2 98.875V56.5H63.45V98.875H28.2ZM112.8 98.875H77.55V56.5H112.8V98.875Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchen);
export default __webpack_public_path__ + "static/media/kitchen.d4bd2071a11d125a730448c54aa092e4.svg";
export { ForwardRef as ReactComponent };